import idx from 'idx';
import * as React from 'react';
import { Query } from 'react-apollo';
import { InjectedRouter } from 'react-router';

import { withRouter } from 'app/context/Router';
import AddButton from 'components/AddButton';
import ErrorReporter from 'app/components/ErrorReporter';
import LayerTrigger from 'components/LayerTrigger';
import ModalTrigger from 'components/ModalTrigger';
import QUERY from 'components/NavigationList/queries/NavigationListCreateGroupAction.gql';
// @ts-ignore
import Timestamp from 'components/Timestamp';
import Tooltip from 'components/Tooltip';
// @ts-ignore
import Group from 'entities/Group';
// @ts-ignore
import GroupCreateModal from 'groups/components/GroupCreateModal';
// @ts-ignore
import getRedirectLocationAfterGroupCreation from 'utils/getRedirectLocationAfterGroupCreation';
import { NavigationListCreateGroupAction as NavigationListCreateGroupActionQuery } from 'components/NavigationList/queries/__generated__/NavigationListCreateGroupAction';

type Props = {
  router: InjectedRouter;
};

function NavigationListCreateGroupAction(props: Props) {
  const handleGroupCreated = (group: Group) => {
    props.router.push(getRedirectLocationAfterGroupCreation(group));
  };

  return (
    <Query<NavigationListCreateGroupActionQuery> query={QUERY} fetchPolicy="network-only">
      {({ loading, error, data }) => {
        if (loading) {
          return null;
        }

        if (error || !data || !data.me) {
          return <ErrorReporter error="NavigationListCreateGroupAction - could not load user" />;
        }

        const canCreateGroup = idx(data.me, _ => _.permissions.can_create_group);
        const mutedUntil = idx(data.me, _ => _.muted_until);

        const button = (
          <AddButton
            disabled={!canCreateGroup}
            weight="semibold"
            className="NavigationList-section-header"
            data-test-selector="create_class_nav_link"
            eventElementName="NavigationList-add-class">
            Create a class
          </AddButton>
        );

        if (canCreateGroup) {
          return (
            <ModalTrigger
              modal={<GroupCreateModal onCreate={handleGroupCreated} onRequestHide={() => {}} />}>
              {button}
            </ModalTrigger>
          );
        }

        if (mutedUntil) {
          return (
            <LayerTrigger
              layer={
                <Tooltip>
                  Your messaging privileges have been temporarily suspended until{' '}
                  <Timestamp date={new Date(mutedUntil)} format="long" />.
                </Tooltip>
              }
              placement="bottom">
              {button}
            </LayerTrigger>
          );
        }

        return button;
      }}
    </Query>
  );
}

export { NavigationListCreateGroupAction };
export default withRouter(NavigationListCreateGroupAction);
